import { BMButton, BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";

import { ERROR_IMAGE_BASE64 } from "../../../assets/error";
import { ErrorSectionItemLargeProps } from "./types";

import BMView from "../../View/BMView";

export default function ErrorSectionLarge({
  title,
  caption,
  button,
  style,
  image,
}: ErrorSectionItemLargeProps) {
  return (
    <BMView flex align="center" justify="center" style={style}>
      <BMView align="center" spacing="lg" style={styles.container}>
        <BMView align="center" spacing="lg">
          <BMView style={styles.imageContainer}>
            <Image
              style={styles.image}
              source={{ uri: image?.link ?? ERROR_IMAGE_BASE64 }}
              alt={image?.altText}
            />
          </BMView>
          <BMView spacing="sm">
            <BMText
              variant="titleSmall"
              ink="BMStyleTextInkPrimary"
              numberOfLines={1}
              lineBreakMode="tail"
              style={styles.textAlignCenter}
            >
              {title || "Something went wrong"}
            </BMText>
            <BMText
              variant="paragraphNormal"
              ink="BMStyleTextInkPrimary"
              numberOfLines={2}
              lineBreakMode="tail"
              style={styles.textAlignCenter}
            >
              {caption ||
                "Sorry, our system encounters a bit of trouble. Please check again later."}
            </BMText>
          </BMView>
        </BMView>
        {button ? (
          Array.isArray(button) ? (
            <BMView spacing="xs">
              {button.map((btn, index) => (
                <BMView key={index} style={styles.buttonContainer}>
                  <BMButton
                    label={btn.label}
                    role={btn.type || "PRIMARY"}
                    size="LARGE"
                    stretchable
                    onPress={btn.onPress}
                  />
                </BMView>
              ))}
            </BMView>
          ) : (
            <BMView style={styles.buttonContainer}>
              <BMButton
                loading={button.loading}
                label={button.label}
                role={button.type || "PRIMARY"}
                size="LARGE"
                stretchable
                onPress={button.onPress}
              />
            </BMView>
          )
        ) : null}
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: BMPrimitives.BMSize.md,
    marginBottom: BMPrimitives.BMSize.xl2,
    marginHorizontal: BMPrimitives.BMSize.md,
  },
  textAlignCenter: {
    textAlign: "center",
  },
  imageContainer: {
    marginVertical: 30,
  },
  image: {
    width: 120,
    height: 120,
  },
  buttonContainer: {
    width: 225,
  },
});
